export default "__VITE_ASSET__55c0ba7b__"